<template>
  <div class="page container">

    <div class="row mt-2">

      <div class="col-12 text-left">


        <h3> Pedidos da lista de <b> {{this.$route.params.listaid}} </b> </h3>
        <hr />

        <button @click="imprimir" class='btn btn-primary hideprint'>
          <PrinterIcon /> Imprimir Todos os pedidos </button>

        <div class='row'>

          <div class="col-12 col-sm-4 section-printer total-produtos">

            <h6 class='mt-5'><b>Total em Produtos</b> </h6>

            <ul class="list-group list-group-flush">
              <li v-for="pp in pedidosPorListaInfo.produtosTotal" :key="'totalprodutos'+pp.id"
                class="list-group-item list-group-flush" style="background:none;">
                <div><b>{{ pp.nome }}</b></div>
                <div class='total'> {{pp.total}} {{pp.medida}} </div>
              </li>
            </ul>






          </div>
          <div class="page-break"></div>

          <div class="col-12 col-sm-8 section-printer pedidos">
            <h6 class='mt-5'><b>Pedidos <small>TOTAL: {{pedidosPorListaInfo.pedidos.length}}</small></b> </h6>
           
            <div v-for="(pedidos,regiao) in pedidosPorListaRegiao" :key="regiao" class="mt-2 col-12 pedido-regiao">
           
               <b> {{ regiao }} </b> ({{pedidos.length}})


              <div v-for="pedido in pedidos" :key="'pedido'+pedido.id"
                class="list-group-item list-group-item-action pedido ">


                <div class="row ">
                  <div class="col-12 pedido-info">

                      <div class="pedido-nome">
                          <h5 class='mt-1 mb-2'><small class="mb-1">{{pedido._datapedido}} </small></h5>
                          <h6 class="mb-1"> Nome: <b>{{pedido.cliente.nome}}</b> </h6>
                          <h6 class="mb-1"> Telefone: <b>{{pedido.cliente.telefone}}</b> </h6>
                          <h6 class="mb-1"> Endereço: <b> {{pedido.cliente.endereco}} {{pedido.cliente.regiao && pedido.cliente.regiao.nome}}</b> </h6>
                          <h6 class="mb-1">Total <b> R$ {{pedido.total}} </b> </h6>
                        
                          <h6 class="mb-1 showprinter">Pago: <b>  {{ pedido.pago ? 'SIM' : 'NÃO' }} </b> </h6>
                        
                          <h6 class="mt-2 hideprinter">
                            <a @click='tooglepago(pedido)' v-if="pedido.pago==false" class='btn btn-red btn-sm'>
                              <SquareIcon /> Não Pago </a>
                            <a @click='tooglepago(pedido)' v-if="pedido.pago==true" class='btn btn-green btn-sm'>
                              <CheckSquareIcon /> Pago </a>
                          </h6>


                          <router-link :to="$route.path+'/'+pedido.id" class='btn btn-primary mt-3 mb-3 hideprint'> ver
                            pedido </router-link>

                      </div>
                      <div class="pedido-produtos">

                      <div class="row mt-3 showprinter">
                        <div class="col">

                          <h5 class="mt-3 hideprinter"> <b>Lista de Produtos</b> </h5>
                          <hr class="hideprinter"/>
                          <ul class="list-group list-group-flush resumo-compra">

                            <li v-for="produto in pedido.produtos" :key="produto.id" class="list-group-item">
                              {{produto.nome}} - <b>{{produto.quantidade}} {{produto.medida}}</b>
                            </li>

                          </ul>

                          <h5 class='mt-3 mb-4' v-if="pedido.cliente.observacao != ''">
                            <b>Observação do cliente:</b><br />
                            {{pedido.cliente.observacao}}
                          </h5>


                          <h3 class="mt-3">Total <b> R$ {{pedido.total}} </b> </h3>



                        </div>

                      </div>
                      </div>

                
                  </div>

                </div>

              </div>
       
              </div>
          </div>





        </div>
      </div>


    </div>


  </div>

</template>

<script>


import has from 'lodash/has'
import groupBy from 'lodash/groupBy'

import { SquareIcon, CheckSquareIcon, Trash2Icon, PrinterIcon } from 'vue-feather-icons'
export default {
      
    components: {SquareIcon, CheckSquareIcon},
    computed:{
      pedidosPorListaInfo:function(){
       return this.$store.getters.listaPedidosById(this.$route.params.listaid)
      },
      pedidosPorListaRegiao:function(){
       let pedidos = this.pedidosPorListaInfo.pedidos
       return groupBy(pedidos,'cliente.regiao.nome');
      },
  },

  created:function(){
    // this.$store.dispatch('getPedidos')
  },

  methods:{
    getTotalProdutos:function(pedidos){
          let produtos = {}

          pedidos.forEach(pedido=>{
              pedido.produtos.forEach( produto =>{
                  let produtoTotal = produtos[produto.id] || {...produto,total:0}
                  produtoTotal.total =  produtoTotal.total + produto.quantidade
                  produtos[produto.id] = {...produtoTotal}
              })
          })

          return produtos
      },
      tooglepago:function(pedido){
          let pago = !pedido.pago
          this.$store.dispatch('updatePedido',{id:pedido.id, pago })
      },

      apagarPedido:async function(pedido){
          let res = await this.$store.dispatch('removePedido',pedido)
          this.$router.replace("/admin/pedidos")
      },

      imprimir:function(){
        window.print();
      }

  }

}
</script>
